// extracted by mini-css-extract-plugin
module.exports = {"contentButton":"ContentButton_contentButton_W77iB","icon":"ContentButton_icon_1ay6N","text":"ContentButton_text_x7rZg"};
    if(module.hot) {
      // 1789136758708
      var cssReload = require("/drone/src/node_modules/@vue/cli-service/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":true});
      module.hot.dispose(cssReload);
      
    }
  